$(window).on("resize", function () {
    customFooterTabScript();
});
jQuery(document).ready(function () {
    customFooterTabScript();
});
function customFooterTabScript() {
    if ($(window).width() <= 1024) {
        $(".sidebar_mobile_wrapper").click(function () {
            $(this).toggleClass('is-active');
            $(this).siblings('.sidebar_content').toggleClass('is-active');
            $('body').addClass('open_Sidebar');
        });

		$('.overlay_background').on('click', function(event) {
			event.preventDefault();
			if ($('.sidebar_content').hasClass('is-active')) {
				$('.sidebar_content').removeClass('is-active');
				$('body').removeClass('open_Sidebar');
			}
		});
    }
}